import React, { Component } from 'react';
import { ApiClient } from '../../libs/apiClient';
import { GenericTable } from '../index';
import $ from 'jquery';
const apiClient = ApiClient.getInstance();
const headers = [
    { title: 'Código' },
    { title: 'Nombre' },
    { title: 'RUT' },
    { title: 'Acción' }
];

class SearchPartnerRefSys extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            fieldSearch: '',
            searchInTable: ''
        }
    }

    componentDidMount() {
        this.closeAction();
        this.GetPartnersData();
    }

    closePartner = async () => {
        $('#searchPartnerRefSys').modal('hide');
    };

    closeAction = () => {
        // const { cleanData } = this.props;
        $('#searchPartnerRefSys').on('hide.bs.modal', function () {
            // cleanData();
        });
    };

    GetPartnersData = async () => {
        const { enableSpinner, showAlert, typeSearch = '' } = this.props
        const { fieldSearch } = this.state
        const data = {
            searchValue: fieldSearch,
            specialSearch: typeSearch
        }
        enableSpinner(true);
        const responseApi = await apiClient.getPartnersRefSys(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return
        }

        await this.setState({
            data: responseApi.data ?? []
        })
    }

    GetSelectedPartnerFather = (object) => {
        const { ReceiveFather } = this.props
        ReceiveFather(object)
    }

    ChangeFieldPartner = async (value) => {
        await this.setState({
            fieldSearch: value
        })
        this.GetPartnersData();
    }


    render() {
        const { typeSearch } = this.props
        const { data } = this.state

        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="searchPartnerRefSys" role="dialog" aria-labelledby="exampleModalLabel" style={{ zIndex: 1055 }} aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                {` Socio de Negocios ${typeSearch !== '' ? typeSearch === 'SearchPossibleAmbassadors' ? '(Posibles embajadores)' : typeSearch === 'SearchPossibleReferreds' ? '(Posibles referidos)' : typeSearch === 'SearchAmbassadors' ? '(Embajadores confirmados)' : '' : ''}`}
                            </h4>
                            <button type="button" className="close" onClick={this.closePartner} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="search-div row">
                                <div className="col-md-12" style={{ width: '100%' }}>
                                    <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc'
                                        style={{ display: 'inline-flex' }} placeholder="Buscar" autoComplete="off"
                                        type='search' aria-controls='dataTableTimbra' value={this.state.fieldSearch} onChange={(event) => this.ChangeFieldPartner(event.target.value)} />
                                </div>

                            </div>
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <GenericTable
                                            headers={headers}
                                            data={data}
                                            idTable={'idSearchPartnerRefSys'}
                                            view={'searchPartnerRefSys'}
                                            enableSearchInTable={true}
                                            actionLabel={this.props.actionLabel}
                                            action={this.GetSelectedPartnerFather}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closePartner} >Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default SearchPartnerRefSys